<template>
    <el-table :data="data" row-key="vdR_SNO" v-loading="isLoading" empty-text="無資料" :default-sort="{ prop: 'index', order: 'ascending' }">
        <el-table-column prop="index" label="名次" width="75" key="inv_sum_index" sortable> </el-table-column>
        <el-table-column prop="fnam" label="客戶名稱" key="inv_sum_fnam">
            <template slot-scope="scope">
                <span style="font-weight: bold">{{ scope.row.fnam }}</span>
            </template>
        </el-table-column>
        <template v-if="mode === 'summary'">
            <el-table-column prop="nonTaxAmount" label="未稅金額" align="right" key="inv_sum_nonTaxAmount" sortable>
                <template slot-scope="scope">
                    <Money :v="scope.row.nonTaxAmount" round />
                </template>
            </el-table-column>
            <el-table-column prop="taxAmount" label="營業稅" align="right" key="inv_sum_taxAmount" sortable>
                <template slot-scope="scope">
                    <Money :v="scope.row.taxAmount" round />
                </template>
            </el-table-column>
            <el-table-column prop="invoiceAmount" label="應收發票總額" align="right" key="inv_sum_invoiceAmount" sortable>
                <template slot-scope="scope">
                    <Money :v="scope.row.invoiceAmount" round />
                </template>
            </el-table-column>
            <el-table-column prop="summaryPER" label="百分比" align="right" key="inv_sum_summaryPER" width="85">
                <template slot-scope="scope"> {{ scope.row.summaryPER }} % </template>
            </el-table-column>
            <el-table-column prop="inV_CNT" label="開立發票張數" align="right" key="inv_sum_inV_CNT" sortable>
                <template slot-scope="scope">
                    <Money :v="scope.row.inV_CNT" round />
                </template>
            </el-table-column>
        </template>
        <template v-else>
            <el-table-column prop="invoiceAmount" label="應收發票總額" align="right" sortable key="inv_arr_invoiceAmount">
                <template slot="header">
                    <span>應收發票總額</span>
                    <ahTip>發票開立總金額（不含折讓計算）</ahTip>
                </template>
                <template slot-scope="scope">
                    <Money :v="scope.row.invoiceAmount" round />
                </template>
            </el-table-column>
            <el-table-column prop="receivedAMT" label="已收款" align="right" key="inv_arr_receivedAMT" sortable>
                <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template slot="header" slot-scope="scope">
                    <span>已收款</span>
                    <ahTip>發票入帳總額（已扣除退款）</ahTip>
                </template>
                <template slot-scope="scope">
                    <Money :v="scope.row.receivedAMT" round />
                </template>
            </el-table-column>
            <el-table-column prop="receivedPER" label="%" align="right" key="inv_arr_receivedPER" width="85">
                <template slot-scope="scope"> {{ scope.row.receivedPER }} % </template>
            </el-table-column>
            <el-table-column prop="unreceivedAMT" align="right" key="inv_arr_unreceivedAMT" sortable>
                <template slot="header">
                    <span>未收款</span>
                    <ahTip>應收發票總額 - 已收款</ahTip>
                </template>
                <template slot-scope="scope">
                    <Money :v="scope.row.unreceivedAMT" round />
                </template>
            </el-table-column>
            <el-table-column prop="unreceivedPER" label="%" align="right" key="inv_arr_unreceivedPER" width="85">
                <template slot-scope="scope"> {{ scope.row.unreceivedPER }} % </template>
            </el-table-column>
        </template>
    </el-table>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        mode: String,
        isLoading: Boolean,
    },
};
</script>
